import React from 'react';
import { SOCIAL_DATA } from "../../../../settings/content/socialProviders";
import styles from './ShareLinks.module.scss'
import { DEBUG } from "../../../../settings/global";

export default function ShareLinks({}) {

    const open = (app_name, url) => {

        const width = 750;
        const height = 500;
        const left = 250;
        const top = 150;
        const options = `width=${width},height=${height},left=${left},top=${top};`

        window.open(url, app_name, options);
    };

    const shareApp = (provider) => {

        if (!provider) return;

        const URL = window.location.href;
        let name, socialURL;

        switch (provider) {
            case 'Twitter':
                name = 'twitter';
                socialURL = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(URL);
                break;
            case 'Facebook':
                name = 'facebook';
                socialURL = "http://www.facebook.com/sharer.php?s=100&u=" + encodeURIComponent(URL);
                break;
            case 'LinkedIn':
                name = 'linkedin';
                socialURL = 'http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(URL) + '&source=';
                break;
            default:
                if (DEBUG) console.warn('Invalid provider in social share buttons');
                break;
        }

        open(name, socialURL);
        return false;
    };

    const share = ['Twitter', 'Facebook', 'LinkedIn'];

    return (
        <div className={styles['socials']}>
            {
                SOCIAL_DATA.map((item, index) => {
                    if (share.includes(item.name)) return (
                        <a
                            style={{
                                '--social-margin': item.margin,
                                '--social-color': item.color[0],
                                '--social-color-dark': item.color?.[1],
                            }}
                            className={`${styles['socials__link']}${item.name === 'Github' ? ' ' + styles['socials__github'] : ''}`}
                            onClick={e => {
                                e.preventDefault();
                                shareApp(item.name);
                            }}
                            target="_blank"
                            aria-label={`Share this page on ${item.name}`}
                            rel='nofollow'
                            draggable='false'
                            key={index}
                            tabIndex='0'
                        >
                            <i className={`${item.icon} ${styles['socials__link__logo']}`} aria-hidden="true"/>
                        </a>
                    )
                })
            }
        </div>
    )
}